import { Paperclip, Plus } from "lucide-react";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { FileTypeEnum } from "@/constants/enums/fileType.enum";
import { NewFileDocumentCard } from "@/components/backOffice/expeditionForm/expeditionDocumentCard";
import { Button } from "@/components/ui/button";
import { UploadFileClientModal } from "@/components/backOffice/expeditionForm/uploadFileModal";

interface Props {
  setNewFilesId: (newFilesId: string[]) => void;
  newFilesId: string[];
}

export const InfoFile = ({ setNewFilesId, newFilesId }: Props) => {
  const { t } = useTranslation("shared");
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [newFiles, setNewFiles] = useState<{ fileId: string; file: File; type: FileTypeEnum }[]>(
    [],
  );

  const handleDeleteFile = async (fileId: string) => {
    const isNewlyAdded = newFiles.some((file) => file.fileId === fileId);

    if (isNewlyAdded) {
      setNewFilesId(newFilesId.filter((id) => id !== fileId));
      setNewFiles(newFiles.filter((file) => file.fileId !== fileId));
    }
  };

  const handleUploadSuccess = (fileId: string, selectedType: string, file: File) => {
    setNewFiles([...newFiles, { fileId, file, type: selectedType as FileTypeEnum }]);
    setNewFilesId([...newFilesId, fileId]);
  };

  return (
    <div className="flex w-full flex-1 flex-col items-center gap-6">
      <div className="flex w-full max-w-[1000px] flex-col items-center justify-center gap-4 rounded-xl border border-gray-200 bg-white p-6">
        <div className="grid grid-cols-[20px_1fr] gap-4 self-start">
          <Paperclip className="h-[20px] w-[20px]" />
          <h2 className="text-xm font-semibold text-black">
            <Trans
              t={t}
              i18nKey="infoFile.title"
              components={{ hint: <span className="text-sm font-normal text-gray-500" /> }}
            />
          </h2>
        </div>
        <div className="flex max-h-[70vh] w-full flex-col gap-8 md:flex">
          <div className="flex flex-col gap-2">
            {newFiles.map((file) => (
              <NewFileDocumentCard key={file.fileId} file={file} onDelete={handleDeleteFile} />
            ))}
          </div>

          <Button
            variant="outline"
            type="button"
            className="self-start"
            onClick={() => setUploadModalOpen(true)}
          >
            <Plus className="mr-2 size-4" />
            {t("infoFile.importFile")}
          </Button>

          <UploadFileClientModal
            open={uploadModalOpen}
            onOpenChange={setUploadModalOpen}
            allowedFileTypes={[FileTypeEnum.EXPEDITION_DAE, FileTypeEnum.OTHER]}
            uploadSuccessCallback={handleUploadSuccess}
          />
        </div>
      </div>
    </div>
  );
};
